/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesPlayListResponseBuildFromJSON, FxIdWebFeaturesPlayListResponseBuildToJSON, } from './FxIdWebFeaturesPlayListResponseBuild';
/**
 * Check if a given object implements the FxIdWebFeaturesPlayListResponse interface.
 */
export function instanceOfFxIdWebFeaturesPlayListResponse(value) {
    if (!('Builds' in value) || value['Builds'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesPlayListResponseFromJSON(json) {
    return FxIdWebFeaturesPlayListResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Builds': (json['Builds'].map(FxIdWebFeaturesPlayListResponseBuildFromJSON)),
    };
}
export function FxIdWebFeaturesPlayListResponseToJSON(json) {
    return FxIdWebFeaturesPlayListResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayListResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Builds': (value['Builds'].map(FxIdWebFeaturesPlayListResponseBuildToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesPlayListResponse.js.map